import { apiRequest } from './client'

/** /api/v1/me 响应 —— 跟 fabric-server::routes::me::MeResponse 对得上。 */
export interface MeResponse {
  tenant: TenantBrief
  capabilities: CapabilityBrief[]
}

export interface TenantBrief {
  ulid: string
  shop_name: string
  plan: string
  status: string
  expires_at: string | null
}

export type CapabilityName =
  | 'miniapp'
  | 'image_search'
  | 'media_assistant'
  | 'business'
  | 'llm_tagging'
  | 'pet_companion'

export interface CapabilityBrief {
  name: CapabilityName
  enabled: boolean
  /** 仅 image_search 有 —— dinov3_local / baidu */
  active_provider?: string
}

export function fetchMe(): Promise<MeResponse> {
  return apiRequest<MeResponse>('/me')
}
